<template>
  <div class="containerBlog">
    <app-Navigation></app-Navigation>
    <app-blogs></app-blogs>
  </div>
</template>

<script>
import navigation from "../components/blog/navigationbar";
import blogs from "../components/blog/blogs";
export default {
  name: "blog",
  components: {
    appNavigation: navigation,
    appBlogs: blogs
  }
};
</script>
